export type AddressOptions = {
  checkOnDevice?: boolean;
  skipOpenApp?: boolean;
};
